import Identity from '../sdk/identity';
import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import { isConfigOptions } from '../sdk/getConfig';

/**
 * @hidden
 */
export enum RecaptchaMethod {
  SIGN_IN = 'SIGN_IN',
  SIGN_UP = 'SIGN_UP',
  MAGIC_LINK = 'MAGIC_LINK',
  RESET_PASSWORD = 'RESET_PASSWORD'
}

/**
 * Throws an error if a recaptcha token is needed but none is passed.
 * This function is meant to be used before making calls to APIs that
 * sometimes require a recaptcha token.
 *
 * @param {string} [recaptchaToken]
 * @returns __Promise__
 * @hidden
 */
export default async function enforceRecaptcha(
  caller: RecaptchaMethod,
  recaptchaToken?: string
): Promise<boolean | APIErrorResponse> {
  const config = await Identity.getConfig();

  if (
    isConfigOptions(config) &&
    ((caller === RecaptchaMethod.MAGIC_LINK && config.magicLinkRecaptcha) ||
      (caller === RecaptchaMethod.SIGN_IN && config.signinRecaptcha) ||
      (caller === RecaptchaMethod.SIGN_UP && config.signupRecaptcha) ||
      (caller === RecaptchaMethod.RESET_PASSWORD && config.resetPasswordRecaptcha)) &&
    !recaptchaToken
  ) {
    throw {
      code: '130001',
      message: 'Captcha token invalid'
    };
  } else {
    return true;
  }
}
